import { supabase } from '../lib/supabase';

export const productService = {
  async getProducts(filters = {}) {
    let query = supabase?.from('products')?.select(`
        *,
        product_targets!product_targets_product_id_fkey(*)
      `)?.order('created_at', { ascending: false });

    if (filters?.category) {
      query = query?.eq('category', filters?.category);
    }

    if (filters?.complianceStatus) {
      query = query?.eq('compliance_status', filters?.complianceStatus);
    }

    if (filters?.search) {
      query = query?.or(`name.ilike.%${filters?.search}%,active_ingredients.ilike.%${filters?.search}%`);
    }

    if (filters?.minRating) {
      query = query?.gte('rating', filters?.minRating);
    }

    const { data, error } = await query;

    if (error) throw error;

    return data?.map(product => ({
      id: product?.id,
      name: product?.name,
      category: product?.category,
      activeIngredients: product?.active_ingredients,
      price: product?.price,
      rating: product?.rating,
      reviewCount: product?.review_count,
      complianceStatus: product?.compliance_status,
      epaNumer: product?.epa_number,
      phi: product?.phi,
      rei: product?.rei,
      modeOfAction: product?.mode_of_action,
      applicationRate: product?.application_rate,
      safetyInfo: product?.safety_info,
      productInfo: product?.product_info,
      ipmNotes: product?.ipm_notes,
      suppliers: product?.suppliers,
      purchaseLink: product?.purchase_link,
      alternatePurchaseLink: product?.alternate_purchase_link,
      productLabelLink: product?.product_label_link,
      sdsLink: product?.sds_link,
      useCase: product?.use_case,
      specialNotes: product?.special_notes,
      notes: product?.notes,
      targets: product?.product_targets?.map(target => ({
        id: target?.id,
        targetName: target?.target_name,
        targetType: target?.target_type,
        efficacyRating: target?.efficacy_rating
      })) || [],
      createdAt: product?.created_at,
      updatedAt: product?.updated_at
    }));
  },

  async getProductById(id) {
    const { data, error } = await supabase?.from('products')?.select(`
        *,
        product_targets!product_targets_product_id_fkey(*)
      `)?.eq('id', id)?.single();

    if (error) throw error;

    return {
      id: data?.id,
      name: data?.name,
      category: data?.category,
      activeIngredients: data?.active_ingredients,
      price: data?.price,
      rating: data?.rating,
      reviewCount: data?.review_count,
      complianceStatus: data?.compliance_status,
      epaNumer: data?.epa_number,
      phi: data?.phi,
      rei: data?.rei,
      modeOfAction: data?.mode_of_action,
      applicationRate: data?.application_rate,
      safetyInfo: data?.safety_info,
      productInfo: data?.product_info,
      ipmNotes: data?.ipm_notes,
      suppliers: data?.suppliers,
      purchaseLink: data?.purchase_link,
      alternatePurchaseLink: data?.alternate_purchase_link,
      productLabelLink: data?.product_label_link,
      sdsLink: data?.sds_link,
      useCase: data?.use_case,
      specialNotes: data?.special_notes,
      notes: data?.notes,
      targets: data?.product_targets?.map(target => ({
        id: target?.id,
        targetName: target?.target_name,
        targetType: target?.target_type,
        efficacyRating: target?.efficacy_rating
      })) || [],
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async getProductCategories() {
    return ['biological', 'chemical', 'organic', 'biological_controls'];
  },

  async getComplianceStatuses() {
    return ['approved', 'pending', 'restricted', 'prohibited'];
  }
};